import React from "react"
import { Toast, ToastBody } from "reactstrap"
import FeaturedRejected from "../assets/images/icons/featured-rejected-icon.svg"
import closeIcon from "../assets/images/icons/close.svg"

function AlertAccessModal({
  open,
  title = "This is an individual user!",
  description = `You can't accept the ICD request from an individual user, invite as business user.`,
  onClose,
}) {
  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <ToastBody>
            <div className="tost-box-wrapper p-0">
              <div className="icon-section">
                <img src={FeaturedRejected} alt="" />
                <div onClick={onClose}>
                  <img className="cp" src={closeIcon} alt="" height={"14px"} />
                </div>
              </div>
              <h4>{title}</h4>
              <p>{description}</p>
            </div>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default AlertAccessModal
